// // import axios from 'axios'
// // import React, { useEffect, useState } from 'react'
// // import endpoints from '../../../endpoint'
// // import {
// //     TableContainer,
// //     Paper,
// //     Table,
// //     TableHead,
// //     TableRow,
// //     TableCell,
// //     TableBody
// // } from '@mui/material';
// // import { useNavigate } from 'react-router-dom';
// // const PartnerRequest = () => {
// //     const [data, setData] = useState()

// //     const navigate = useNavigate();
// //     useEffect(() => {

// //         const fetchPartnerRequest = async () => {
// //             try {
// //                 const response = await axios.get(endpoints.serverBaseUrl + "api/partner", {
// //                     withCredentials: true,
// //                     headers: {
// //                         Authorization: `Bearer ${sessionStorage.getItem("token")}`
// //                     }

// //                 });

// //                 if (response.data.success) {
// //                     console.log(response.data.data)
// //                     setData(response.data.data)
// //                 }

// //             } catch (error) {
// //                 console.log(error.message)
// //             }
// //         }

// //         fetchPartnerRequest();
// //     }, [])
// //     console.log(data)

// //     const handleNavigate = (partnerId) => {
// //         navigate("/admin-dashboard/partner/info/" + partnerId)
// //     }

// //     return (
// //         <TableContainer component={Paper}>
// //             <Table>
// //                 <TableHead>
// //                     <TableRow>
// //                         <TableCell>Name</TableCell>
// //                         <TableCell>Email</TableCell>
// //                         <TableCell>Phone</TableCell>
// //                         <TableCell>Role</TableCell>
// //                         <TableCell>status</TableCell>
// //                         <TableCell>Created At</TableCell>
// //                     </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                     {data?.map((user) => (
// //                         <TableRow onClick={()=>handleNavigate(user?._id)} key={user?.userId?._id}>
// //                             <TableCell>
// //                                 {[user?.userId?.firstName, user?.userId?.lastName, user?.userId?.displayName]
// //                                     ?.filter(Boolean)
// //                                     .join(' ')}
// //                             </TableCell>
// //                             <TableCell>{user?.email || user?.userId?.email}</TableCell>
// //                             <TableCell>{user?.mobile || user?.userId?.phone}</TableCell>
// //                             <TableCell>{user?.userId?.role}</TableCell>
// //                             <TableCell>{user?.status}</TableCell>
// //                             <TableCell>
// //                                 {new Date(user?.userId?.createdAt).toLocaleDateString()}
// //                             </TableCell>
// //                         </TableRow>
// //                     ))}
// //                 </TableBody>
// //             </Table>
// //         </TableContainer>
// //     );
// // };
// // export default PartnerRequest
// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import endpoints from '../../../endpoint';
// import {
//     TableContainer,
//     Paper,
//     Table,
//     TableHead,
//     TableRow,
//     TableCell,
//     TableBody,
//     Button,
//     Select,
//     MenuItem
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';

// const PartnerRequest = () => {
//     const [data, setData] = useState([]);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchPartnerRequest = async () => {
//             try {
//                 const response = await axios.get(endpoints.serverBaseUrl + "api/partner", {
//                     withCredentials: true,
//                     headers: {
//                         Authorization: `Bearer ${sessionStorage.getItem("token")}`
//                     }
//                 });
//                 if (response.data.success) {
//                     setData(response.data.data);
//                 }
//             } catch (error) {
//                 console.log(error.message);
//             }
//         };
//         fetchPartnerRequest();
//     }, []);

//     const handleNavigate = (partnerId) => {
//         navigate("/admin-dashboard/partner/info/" + partnerId);
//     };

//     const handleStatusChange = async (partnerId, status) => {
//         try {
//             const response = await axios.post(
//                 endpoints.serverBaseUrl + "api/partner/approve",
//                 { partnerId, status },
//                 {
//                     withCredentials: true,
//                     headers: {
//                         Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//                         'Content-Type': 'application/json'
//                     }
//                 }
//             );
//             if (response.data.message) {
//                 setData((prevData) =>
//                     prevData.map(user =>
//                         user._id === partnerId ? { ...user, status } : user
//                     )
//                 );
//             }
//         } catch (error) {
//             console.log("Error updating partner status:", error.message);
//         }
//     };

//     return (
//         <TableContainer component={Paper}>
//             <Table>
//                 <TableHead>
//                     <TableRow>
//                         <TableCell>Name</TableCell>
//                         <TableCell>Email</TableCell>
//                         <TableCell>Phone</TableCell>
//                         <TableCell>Role</TableCell>
//                         <TableCell>Status</TableCell>
//                         <TableCell>Created At</TableCell>
//                         <TableCell>Actions</TableCell>
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {data.map((user) => (
//                         <TableRow key={user?._id}>
//                             <TableCell onClick={() => handleNavigate(user?._id)} style={{ cursor: 'pointer' }}>
//                                 {[user?.userId?.firstName, user?.userId?.lastName, user?.userId?.displayName]
//                                     .filter(Boolean)
//                                     .join(' ')}
//                             </TableCell>
//                             <TableCell>{user?.email || user?.userId?.email}</TableCell>
//                             <TableCell>{user?.mobile || user?.userId?.phone}</TableCell>
//                             <TableCell>{user?.userId?.role}</TableCell>
//                             <TableCell>
//                                 <Select
//                                     value={user?.status || "pending"}
//                                     onChange={(e) => handleStatusChange(user._id, e.target.value)}
//                                 >
//                                     <MenuItem value="pending">Pending</MenuItem>
//                                     <MenuItem value="approved">Approved</MenuItem>
//                                     <MenuItem value="rejected">Rejected</MenuItem>
//                                 </Select>
//                             </TableCell>
//                             <TableCell>{new Date(user?.userId?.createdAt).toLocaleDateString()}</TableCell>
//                         </TableRow>
//                     ))}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );
// };

// export default PartnerRequest;
import axios from "axios";
import React, { useEffect, useState } from "react";
import endpoints from "../../../endpoint";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../comman/Loader";
import { fetchPartner } from "../../../redux/slices/partnerSlice";

const PartnerRequest = () => {
  const [filterStatus, setFilterStatus] = useState("all");
  const partner = useSelector((state) => state?.partner);
  const loading = partner?.loading;
  const dispatch = useDispatch();

  const data = partner?.partner;
  console.log(data);
  useEffect(() => {
    if (data?.length > 0) {
      return;
    }
    dispatch(fetchPartner());
  }, []);

  if (loading) return <Loader />;

  const handleStatusChange = async (partnerId, status) => {
    try {
      const response = await axios.post(
        endpoints.serverBaseUrl + "api/partner/approve",
        { partnerId, status },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.message) {
        dispatch(fetchPartner());
      }
    } catch (error) {
      console.log("Error updating partner status:", error.message);
    }
  };

  const filteredData =
    filterStatus === "all"
      ? data
      : data?.filter((user) => user?.status === filterStatus);

  return (
    <>
      <FormControl style={{ margin: "10px", minWidth: 120 }}>
        <InputLabel>Status</InputLabel>
        <Select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="approved">Approved</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
        </Select>
      </FormControl>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((user) => (
              <TableRow key={user?._id}>
                <TableCell style={{ cursor: "pointer" }}>
                  {[
                    user?.userId?.firstName,
                    user?.userId?.lastName,
                    user?.userId?.displayName,
                  ]
                    .filter(Boolean)
                    .join(" ")}
                </TableCell>
                <TableCell>{user?.email || user?.userId?.email}</TableCell>
                <TableCell>{user?.mobile || user?.userId?.phone}</TableCell>
                <TableCell>{user?.userId?.role}</TableCell>
                <TableCell>{user?.status}</TableCell>

                <TableCell>
                  {new Date(user?.userId?.createdAt).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  <Select
                    value={user?.status || "pending"}
                    onChange={(e) =>
                      handleStatusChange(user._id, e.target.value)
                    }
                  >
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default PartnerRequest;
